/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

import {ColDefCustom, default as AgGridVueCustomTsx} from "../../../../components/agGridCustom/agGridVueCustomTsx";
import _ from 'lodash'
import ListPageService from "../../../../types/ListPage";
import override from "../../../../dectorators/override";
import {QueryFormVOI} from "../../../../components/queryForm/queryForm";
import AlarmSearchApi, { AlarmStatisticsDOI } from '../api/alarmStatisticsApi';
import AlarmSearch from '../alarmStatistics';
import AlarmStatistics from '../alarmStatistics';
import EnumStationType from 'src/enums/enumStationType';
import AreaCascader from 'src/components/areaCascader/areaCascader';
import DatePicker from 'src/types/iview/DatePicker';
import EnumAlarmType from 'src/enums/enumAlarmType';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import FileUtil from 'src/util/fileUtil';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';

export default class AlarmStatisticsService extends ListPageService {
    ctx: AlarmStatistics;
    
    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

	constructor (ctx: AlarmSearch) {
		super()
		this.ctx = ctx
	}
	createColumns (): ColDefCustom [] {
		let t = this
		return [
			{
				headerName: '区域',
				field: 'code',
				minWidth: 190,
                cellRenderer(params) {
                    let data: AlarmStatisticsDOI.RowDataI = params.data;
                    // @ts-ignore
                    if(data.footer) {
                        return '合计'
                    }
                    return data.province_name+data.city_name+data.district_name
                }
			},
            {
                headerName: '流域',
                field: 'basin',
                minWidth: 100,
            },
			{
				headerName: '站点名称',
				field: 'name',
				minWidth: 120
			},
			{
				headerName: '因子超标',
				field: 'over_warning',
				minWidth: 100,
			},
			{
				headerName: '电量不足',
				field: 'power_low',
				minWidth: 100
			},
			{
				headerName: '设备偏移',
				field: 'device_lost',
				minWidth: 100
			},
			{
				headerName: '设备维护周期不足',
				field: 'over_time',
				minWidth: 100
			},{
				headerName: '仪表故障告警',
				field: 'meter_break',
				minWidth: 100,
			},
			{
				headerName: '设备离线',
				field: 'device_offline',
				minWidth: 100
			},
			{
				headerName: '仪表常规告警',
				field: 'meter_warning',
				minWidth: 100
			},
			{
				headerName: '系统故障告警',
				field: 'sys_break',
				minWidth: 100
			},{
				headerName: '系统故障告警',
				field: 'sys_break',
				minWidth: 100
			},
			{
				headerName: '总报警数',
				field: 'count',
				minWidth: 100
			},
			{
				headerName: '已通知',
				field: 'processed',
				minWidth: 100,
			},{
				headerName: '未通知',
				field: 'untreated',
				minWidth: 100,
			}
		]
	}


    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: AreaCascader,
                label: '区域',
                field: 'area：',
                width: 320,
                labelWidth: 50,
                dealParam(value) {
                    return {
                        province_id: value[0],
                        city_id: value[1],
                        district_id: value[2],
                    };
                },
                props: { value: [], type: this.type },
            }, {
                component: EntitySelect,
                label: '所属流域',
                field: 'basin',
                labelWidth: 60,
                width:160,
                props: { value: null, type: EnumEntity.Basin.getId() },
            },
           {
				component: DatePicker,
				label: '时间',
                field: 'time',
                width: 300,
                realField: ['start_time','end_time'],
                props: {value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间'},
            }
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '导出',
                type: 'info',
                async onClick() {
                    let { code, data } = await AlarmSearchApi.exportAll(
                        t.ctx.queryForm.getQueryObj<AlarmStatisticsDOI.QueryRowDataParamsI>(),
                    );
                    if (code === 0) {
                        FileUtil.download(data.download_url);
                    }
                },
            },
        ];
    }


	@override
	initSearchParams (): void {
		this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<AlarmStatisticsDOI.QueryRowDataParamsI>(),
            site_type: this.type,
            page_index: this.ctx.currentPage,
            page_size: this.ctx.pageSize,
        }
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
		let {code, data} = await AlarmSearchApi.searchList({
            ...ctx.searchParams
		})
		ag.hideLoading()
		if (code === 0) {
            ctx.statistic = data
            ctx.rowData = data.data_info || [];
            this.setFooter()
		}
    }
    async setFooter () {
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		let obj: any = {
            footer: true,
            count: this.ctx.statistic.count_count,
            untreated: this.ctx.statistic.untreated_count,
            processed: this.ctx.statistic.processed_count,
        }
		EnumAlarmType.getList().forEach(i=> {
            obj[i.getCode()] = this.ctx.statistic[i.getCode()+'_count']
        });
		(await ag.getApi()).setPinnedBottomRowData([obj])
	}

}
